class BalanceRequest {
  id = null;
  amount = 0;
  claimtype = ""; //Cash or Bank strings
  status = null;
  bankname = "";
  sentbyname = "";

  created_at = null;
  createdby = null;
  updatedby = null;

  constructor() {
    this.created_at = new Date();
  }
}
export default BalanceRequest;
